import { render, staticRenderFns } from "./AscDialogSubtitle.vue?vue&type=template&id=3b2f0af2&"
import script from "./AscDialogSubtitle.vue?vue&type=script&lang=js&"
export * from "./AscDialogSubtitle.vue?vue&type=script&lang=js&"
import style0 from "./AscDialogSubtitle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports